import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text, useTheme } from '@ublend-npm/aulaui-core';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import * as types from '../types';
import Emoji from '../../../emoji/Emoji';
import EmojiUtils from '../../../../../../core/utils/emoji';
import { DARK } from '../../../../../../core/constants/theme';
// import { StatusText } from './ConversationModalTitle.styled';

const ConversationModalTitle = ({ title, status }) => {
  const { palette } = useTheme();
  const isDarkMode = palette?.mode === DARK;
  const statusTextColor = isDarkMode
    ? 'rgba(255, 255, 255, 0.7)'
    : 'rgba(0, 0, 0, 0.6)';
  return (
    <Box>
      <Text
        aria-label={title}
        tabIndex={0}
        fontSize="1.25rem"
        fontWeight="600"
        lineHeight="160%"
        letterSpacing="0.15px"
        textOverflow="ellipsis"
        maxLines={1}
      >
        {title}
      </Text>
      {/* This is the code for the status text and emoji in the conversation modal header */}
      {status ? (
        <Box display="flex" alignItems="center" gap="0.25rem">
          <Box
            style={{
              placeContent: 'center',
              lineHeight: 'normal',
              display: 'grid',
            }}
          >
            <Emoji emoji={EmojiUtils.getFromShortName(status.emojiName)} />
          </Box>
          <i
            style={{
              fontSize: '14px',
              fontWeight: 400,
              color: statusTextColor,
            }}
          >
            {status.text}
          </i>
        </Box>
      ) : null}
    </Box>
  );
};

ConversationModalTitle.propTypes = {
  title: PropTypes.string.isRequired,
  status: types.Status,
  conversationMuted: PropTypes.bool,
};

ConversationModalTitle.defaultProps = {
  status: null,
  conversationMuted: false,
};

export default ConversationModalTitle;
